/**
* @file 资源管理-角色权限
* */
<template>
  <div id="role">
    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
                  addText="创建角色" @addFn="addFn">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{row}" class="custom-action">
            <el-tooltip content="编辑" placement="top">
              <i class="iconfont icon-compile" @click="compileClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <i class="iconfont icon-delete" @click="removeClick(row)"></i>
            </el-tooltip>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <div v-if="item.prop === 'created'">{{ row.created | filterTime }}</div>
        <div v-else-if="item.prop === 'boundUserCount'">
          <el-tag v-if="row.boundUserCount > 0" type="warning" size="mini">{{ row.boundUserCount }} 人</el-tag>
          <el-tag v-else type="info" size="mini">未绑定</el-tag>
        </div>
        <span v-else>{{ row[item.prop] }}</span>
      </template>
    </custom-table>

    <!-- 删除角色-绑定用户确认弹窗 -->
    <el-dialog
      :visible.sync="boundUsersDialog.visible"
      title="删除角色"
      width="520px"
      :close-on-click-modal="false"
    >
      <div v-if="boundUsersDialog.users.length > 0">
        <el-alert
          :title="`该角色绑定了 ${boundUsersDialog.users.length} 个用户，删除前请先将这些用户切换到其他角色。`"
          type="warning"
          show-icon
          :closable="false"
          style="margin-bottom: 14px"
        ></el-alert>
        <el-table :data="boundUsersDialog.users" size="small" border stripe max-height="280">
          <el-table-column label="姓名" prop="name" min-width="90">
            <template slot-scope="{ row }">{{ row.name || '-' }}</template>
          </el-table-column>
          <el-table-column label="手机号" prop="phone" min-width="120"></el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="{ row }">
              <el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">
                {{ row.status === 1 ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align:right;margin-top:14px">
          <el-button @click="boundUsersDialog.visible = false">关闭</el-button>
          <el-button type="primary" @click="$router.push('/member')">前往账号管理处理</el-button>
        </div>
      </div>
      <div v-else>
        <el-alert title="该角色当前无绑定用户，可以安全删除。" type="success" show-icon :closable="false" style="margin-bottom:14px"></el-alert>
        <div style="text-align:right">
          <el-button @click="boundUsersDialog.visible = false">取消</el-button>
          <el-button type="danger" :loading="boundUsersDialog.delLoading" @click="confirmDelete">确认删除</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog destroy-on-close :visible.sync="show" title="创建角色" width="500px"
               :before-close="()=>(show =false)">
      <div>
        <p class="util-remark">您可创建固定角色类型快速创建角色，也可选择自定义角色</p>
        <div style="height: 20px"></div>
        <div>
          <el-select v-model="organizationId" filterable>
            <el-option v-for="( item, i   ) in   organizations  " :key="i"
                       :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </div>
        <div style="height: 20px"></div>
        <div class="flex-between">
          <el-card class="box-card" style="width: 120px">
            <div @click="clickRoute('organization')" class="flex-center column">
              <img style="width: 50px" src="@/assets/img/role/jigou.png" alt="">
              机构管理员
            </div>
          </el-card>
          <el-card class="box-card" style="width: 120px">
            <div @click="clickRoute('channel')" class="flex-center column">
              <img style="width: 50px" src="@/assets/img/role/qudao.png" alt="">
              渠道商
            </div>
          </el-card>
          <el-card class="box-card" style="width: 120px">
            <div @click="clickRoute('custom')" class="flex-center column">
              <img style="width: 50px" src="@/assets/img/role/zidingyi.png" alt="">
              自定义
            </div>
          </el-card>
        </div>
      </div>

    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "role",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/role',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          {
            type: "input",
            field: "name",
            name: "角色名称",
            value: ""
          }
        ]
      },
      columns: [
        {prop: 'roleName', label: '角色名称'},
        {prop: 'organizationName', label: '机构名称'},
        {prop: 'boundUserCount', label: '绑定用户数', width: 110},
        {prop: 'created', label: '创建时间'}
      ],
      show: false,
      organizationId: "",
      menuList: [],
      boundUsersDialog: {
        visible: false,
        users: [],
        loading: false,
        delLoading: false,
        row: null
      }
    }
  },
  async created() {
    await this.mixinOrganizations()
    this.organizationId = this.mixinUserInfo.organizationId
  },
  methods: {
    clickRoute(type) {
      if (!this.organizationId) {
        this.$message.error('请选择机构名称')
        return
      }
      this.$router.push({
        path: '/roleForm',
        query: {
          type: type,
          organizationId: this.organizationId
        }
      })
    },
    /* 点击创建角色 */
    addFn() {
      if (this.mixinUserInfo.platformType === 3) {
        this.show = true
      } else {
        this.$router.push('/roleForm')
      }

    },
    /* 编辑角色 */
    compileClick(row) {
      this.$router.push({path: '/roleForm', query: {id: row.id}})
    },
    /* 删除角色 - 先查绑定用户再决定 */
    async removeClick(row) {
      this.boundUsersDialog.row = row
      this.boundUsersDialog.users = []
      this.boundUsersDialog.loading = true
      this.boundUsersDialog.visible = true
      try {
        const res = await this.$axios.get(`/api/v1/manage/role/${row.id}/bound-users`, {
          appKey: this.mixinUserInfo?.appKey
        })
        if (res && res.code === 1) {
          this.boundUsersDialog.users = res.data || []
        }
      } finally {
        this.boundUsersDialog.loading = false
      }
    },
    /* 确认删除角色（仅在无绑定用户时可执行） */
    async confirmDelete() {
      const row = this.boundUsersDialog.row
      if (!row) return
      this.boundUsersDialog.delLoading = true
      try {
        const data = await this.$axios.delete('/api/v1/manage/role', {
          id: row.id,
          appKey: this.mixinUserInfo?.appKey
        })
        if (data && data.code === 1) {
          this.$message.success('删除成功')
          this.boundUsersDialog.visible = false
          this.$refs.customTable.listFn()
        }
      } finally {
        this.boundUsersDialog.delLoading = false
      }
    }
  }
}
</script>